export default __webpack_public_path__ + "static/media/flags.99f63ae7.png";